let stickyObserver = null;

export default () => {
    const $ = document.querySelector.bind(document)
    const showEl = $('#sticky-show')
    const hideEl = $('.footer')
    const stickyEl = $('#sticky-bar')

    // Re-running this (e.g. after an in-place product switch remounts #sticky-show)
    // must not leave the previous observer attached to the persistent .footer, or
    // stale observers pile up and keep firing on scroll.
    if (stickyObserver) {
      stickyObserver.disconnect();
      stickyObserver = null;
    }

    const watchEl = (el1, el2, cb) => {
      let ve = 0, he = 0, init = false;
      const els = [el1, el2]
      const IO = new IntersectionObserver((ObserverEntry) => {
        ObserverEntry.forEach(entry => {
          const { isIntersecting, target } = entry
          if(init) {
            if(isIntersecting) {
              cb(false)
            } else {
              cb(true)
            }
          }else {
            if(isIntersecting) { he++; }
            else {
              if(!he && els.includes(target)){
                ve++;
                if(ve === 2) {
                  init = true
                  const { top } = el1.getBoundingClientRect()
                  if(top < window.innerHeight) cb && cb(true);
                }
              }else init = true
            }
          }
        })
      }, {
        rootMargin: '0px',
        threshold: 0
      })
  
      el1 && IO.observe(el1)
      el2 && IO.observe(el2)
      stickyObserver = IO
    }
  
    watchEl(showEl, hideEl, function(sh) {
      // product-sticky-bar__wrapper--open
      if(sh === true){
        stickyEl.classList.add('sb--show')
        stickyEl.setAttribute('aria-hidden', false);
      }else{ 
        // If sticky bar gets close while interacting with swatches on safari
        // if (stickyEl.classList.contains('sb--show')) {
        //   const isWrapperOpen = stickyEl.querySelector('.product-sticky-bar__wrapper--open');
    
        //   if (isWrapperOpen) {
        //     console.log('Sticky bar wrapper is open, skipping hide');
        //     return;
        //   }
        // }
        stickyEl.classList.remove('sb--show');
        stickyEl.setAttribute('aria-hidden', true);
      }
    })
  }